module.exports = __webpack_public_path__ + "img/main_16.adc4eebe.jpg";